import * as authActions from "./authActions";
import * as formActions from "./formActions";
import * as requestActions from "./requestActions";
import * as userAction from "./userActions";

const ActionCreators = Object.assign(
  {},
  authActions,
  formActions,
  requestActions,
  userAction
);

export default ActionCreators;
